module.exports = __webpack_public_path__ + "img/甘肃文旅_02.79afc1db.jpg";